import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { Dashboard } from "@/pages/Dashboard";
import { Organizations } from "@/pages/Organizations";
import { OrganizationDetail } from "@/pages/OrganizationDetail";
import { Services } from "@/pages/Services";
import { ServiceDetail } from "@/pages/ServiceDetail";
import { Leads } from "@/pages/Leads";
import { LeadDetail } from "@/pages/LeadDetail";
import { Users } from "@/pages/Users";
import { MenuEditorOverview } from "@/pages/MenuEditorOverview";
import { MenuEditorUsage } from "@/pages/MenuEditorUsage";
import { AIAssistantPage } from "@/pages/AIAssistantPage";
import { AIConversationDetailPage } from "@/pages/AIConversationDetailPage";
import { Login } from "@/pages/Login";
import { useAuth } from "@/lib/auth";

function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Dashboard />} />
        {/* Organization routes (primary) */}
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/organizations/:id" element={<OrganizationDetail />} />
        {/* Backwards compatibility aliases */}
        <Route path="/customers" element={<Organizations />} />
        <Route path="/customers/:id" element={<OrganizationDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceDetail />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/leads/:id" element={<LeadDetail />} />
        <Route path="/users" element={<Users />} />
        <Route path="/menu-editor" element={<MenuEditorOverview />} />
        <Route path="/menu-editor/imports" element={<MenuEditorUsage />} />
        <Route path="/menu-editor/ai-asistent" element={<AIAssistantPage />} />
        <Route
          path="/menu-editor/ai-asistent/:id"
          element={<AIConversationDetailPage />}
        />
      </Route>
    </Routes>
  );
}
